import { render, staticRenderFns } from "./hezhi2.vue?vue&type=template&id=f0015a7c&"
import script from "./hezhi2.vue?vue&type=script&lang=js&"
export * from "./hezhi2.vue?vue&type=script&lang=js&"
import style0 from "./hezhi2.vue?vue&type=style&index=0&id=f0015a7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports